import {EntryTypeList} from "./EntryTypeList";
import {EntryTypeEdit} from "./EntryTypeEdit";
import {EntryTypeCreate} from "./EntryTypeCreate";

export default {
    list: EntryTypeList,
    create: EntryTypeCreate,
    edit: EntryTypeEdit
};
